import { initSlider } from "../../ui/slider/slider";

import "./jiffymade-landing-reviews.scss";

export const initReviews = () => {
  initSlider({
    containerSelector: ".js-jiffymade-landing-reviews-section-swiper",
    spaceBetween: 16
  });
};

export default initReviews;
